<script>
export default {
  methods: {
    _emmiter(name) {
      this.$emit('emmiter', {
        name: name,
        data: this.field,
      });
    },

    fieldReady() {
      this._emmiter('field-ready');
    },

    fieldReadyNextTick() {
      this.$nextTick(() => {
        this._emmiter('field-ready');
      });
    },

    emitChange({ newValue, makeDirty = true }) {
      const valueChanges = {
        name: this.field.name,
        type: this.field.type,
        value: newValue,
      };

      this.$emit('change', { valueChanges, makeDirty });
    },
  },
};
</script>
